import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 47,
  initialSeconds = 12
}: CountdownProps) {
  const [time, setTime] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  return <div className="flex gap-2 justify-center items-center" data-id="element-40">
      <TimeBlock value={pad(time.hours)} data-id="element-41" />
      <span className="text-2xl md:text-3xl font-bold text-red-600" data-id="element-42">:</span>
      <TimeBlock value={pad(time.minutes)} data-id="element-43" />
      <span className="text-2xl md:text-3xl font-bold text-red-600" data-id="element-44">:</span>
      <TimeBlock value={pad(time.seconds)} data-id="element-45" />
    </div>;
}
function TimeBlock({
  value
}: {
  value: string;
}) {
  return <motion.div key={value} initial={{
    scale: 1.1
  }} animate={{
    scale: 1
  }} className="bg-red-600 text-white font-bold text-2xl md:text-4xl px-3 md:px-4 py-2 md:py-3 rounded-lg shadow-lg min-w-[3rem] md:min-w-[4rem] text-center" data-id="element-46">
      {value}
    </motion.div>;
}